import { combineReducers } from 'redux'

import resultados from './despesasPorCredor'

export default combineReducers({ resultados })
